/* eslint-disable no-unneeded-ternary */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import {TextInputMask} from 'tp-react-web-masked-text';
import Label from '../Label';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    name: string;
    label: string;
    size_label: string;
    size_input: string;
    digits?: number;
    hideErrors?: boolean;
    labelFilter?: boolean;
    textRight?: boolean;
    data_tip?: string;
}

const InputLabelOnlyNumbers: React.FC<Props> = ({
    name,
    required,
    label,
    size_input,
    size_label,
    digits,
    hideErrors,
    labelFilter,
    textRight,
    data_tip,
    ...otherProps
}) => {
    const {
        control,
        formState: {errors},
        getValues
    } = useFormContext();

    return (
        <>
            <Label
                required={required}
                respAlt={labelFilter ? false : true}
                title={label}
                data_tip={data_tip}
                col={`col-sm-${size_label} ${textRight ? 'text-right' : ''}`}
                to={name}
            />
            <div
                className={`col-sm-${size_input} ${
                    labelFilter ? 'resp-form2' : 'resp-form'
                }`}
            >
                <Controller
                    name={`${name}`}
                    control={control}
                    render={({field}) => (
                        <TextInputMask
                            className="form-control form-control-sm"
                            disabled={getValues('form_action') === 'view'}
                            {...otherProps}
                            {...field}
                            onChange={(event) => {
                                field.onChange(event);
                                otherProps.onChange &&
                                    otherProps.onChange(event as any);
                            }}
                            kind={!digits ? 'only-numbers' : 'custom'}
                            options={{
                                mask: digits ? '9'.repeat(digits) : undefined
                            }}
                        />
                    )}
                />
                {errors && errors[`${name}`] && !hideErrors && (
                    <span className="span text-danger text-min-sm">
                        {errors[`${name}`].message}
                    </span>
                )}
            </div>
        </>
    );
};

export default InputLabelOnlyNumbers;
